export default "__VITE_ASSET__C0pad7Gm__"